<div class="page-not-found-container">
  <section id="fof" class="error-section">
    <div class="error-content">
      <div class="error-code-container" *ngIf="!isBackendError && !isSubdomainUnavailable">
        <h1 class="error-code">
          <span class="digit">4</span>
          <span class="digit">0</span>
          <span class="digit">4</span>
        </h1>
      </div>
      <div class="error-code-container" *ngIf="isBackendError">
        <h1 class="error-code">
          <span class="digit">5</span>
          <span class="digit">0</span>
          <span class="digit">3</span>
        </h1>
      </div>
      <div class="error-code-container" *ngIf="isSubdomainUnavailable">
        <h1 class="error-code">
          <span class="digit">4</span>
          <span class="digit">0</span>
          <span class="digit">4</span>
        </h1>
      </div>
      <div class="error-message" *ngIf="!isBackendError && !isSubdomainUnavailable">
        <h2 class="error-title">Page Not Found</h2>
        <p class="error-subtitle">Sorry, the page you are looking for does not exist.</p>
        <p class="error-description"> Please try again.</p>
      </div>
      <div class="error-message" *ngIf="isBackendError">
        <h2 class="error-title">Service Unavailable</h2>
        <p class="error-subtitle">Unable to connect to the server.</p>
        <p class="error-description">Please check your connection and try again later.</p>
      </div>
      <div class="error-message" *ngIf="isSubdomainUnavailable">
        <h2 class="error-title">Subdomain not available</h2>
        <p class="error-subtitle">
          The ButlerMax subdomain you entered does not exist or cannot be accessed.
        </p>
        <p class="error-description">Please check the URL and try again.</p>
      </div>
      <div class="error-actions">
        <a [routerLink]="homeRoute" class="text-link" *ngIf="!isBackendError && !isSubdomainUnavailable">&larr; {{'GoHome'|translate}}</a>
        <span class="separator" *ngIf="!isBackendError && !isSubdomainUnavailable">|</span>
        <a [routerLink]="homeRoute" class="text-link" *ngIf="isBackendError">Retry </a>
        <a [routerLink]="homeRoute" class="text-link" *ngIf="isSubdomainUnavailable">Retry</a>
        <a href="javascript:history.go(-1)" class="text-link" *ngIf="!isBackendError && !isSubdomainUnavailable">{{'GoBack'|translate}} &rarr;</a>
      </div>
    </div>
  </section>
</div>